import { connect } from "react-redux";
import FoldersTable from "../components/FoldersTable";
import { changeFoldersSort, deleteFolder, updateFolder } from "../actions";

export default connect(
  (state) => ({
    folders: state.folders.folders,
    foldersSort: state.folders.sort,
    tableScrollDisabled: state.loader.tableScrollDisabled,
  }),
  (dispatch) => ({
    changeFoldersSort: (sort) => {
      dispatch(changeFoldersSort(sort));
    },
    updateFolder: (folderDatas) => {
      dispatch(updateFolder(folderDatas));
    },
    deleteFolder: (folderId) => {
      dispatch(deleteFolder(folderId));
    },
  }),
)(FoldersTable);
